import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IRoute } from '../../../../../core/interfaces/route.interface';

interface IPageGs0050 {
    valeursEcran: any;
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}
/* @ngInject */
export default function Gs0050Controller(Formulaire: IFormulaireClass,
    ecranDetails: IEcranDetailsResourcesEntite,
    gs2006Route:IRoute,
    FormulaireItem: IFormulaireItemClass) {
    const vm: IPageGs0050 = this;
    vm.valeursEcran = ecranDetails.valeurs;

    vm.multiOccurrenceOptions = {
        navigatePage: gs2006Route.NAME,
        fonctions: { 
            rechercheCollapsable: false 
        },
        colonnesFixesGauche: [
            { nom: 'rqtmne', largeur: 170 }
        ],
        colonnesVisibles: [
            { nom: 'rqtnom', largeur: 150 },
            { nom: 'rqthlp', largeur: 250 },
            { nom: 'rqtfrm', largeur: 250 },
            { nom: 'rqtwhr', largeur: 100 },
            { nom: 'rqtflgmul', largeur: 100 },
            { nom: 'rqtflgent', largeur: 100 },
            { nom: 'rqtflgfil', largeur: 100 },
            { nom: 't_rqtmne', largeur: 100 },
            { nom: 't_rqtnom', largeur: 100 },
            { nom: 'rqtwhrparfil', largeur: 190 },
            { nom: 'rqtwhrparaff', largeur: 190},
            { nom: 'rqtnivaggmin', largeur: 100 },
            { nom: 'rqtflgdateff', largeur: 100 },
            { nom: 'rqtflgdatdebfin', largeur: 100 },
            { nom: 'rqtflgppa', largeur: 100 },
            { nom: 'rqtflgunp', largeur: 100 },
            { nom: 'rqtflgpec', largeur: 100 }
        ]
    };
}
